import { render, staticRenderFns } from "./DocumentPortalSection.vue?vue&type=template&id=d0d7e864&scoped=true&"
import script from "./DocumentPortalSection.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocumentPortalSection.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DocumentPortalSection.vue?vue&type=style&index=0&id=d0d7e864&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d7e864",
  null
  
)

export default component.exports